import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from '../styles.scss'

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)

        this.state = {
            hasError: false,
        }
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true,
        })

        console.info(`Encountered an error when trying to display the settings... | Message: ${error} | StackTrace: ${JSON.stringify(info)}`)
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={styles.section}>
                    <div className={styles.wrap}>
                        <p>
                            Something went horribly wrong...!
                            <br />
                            Please try to reload your Launcher UI, or contact CCP directly.
                        </p>
                    </div>
                </div>
            )
        }

        return this.props.children
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node,
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./src/features/Settings/error/index.js